import type { NostrMetadata } from '@nostrify/nostrify';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { displayName, sanitizeUrl, shortNpub } from '@/lib/tombolo';
import { cn } from '@/lib/utils';

interface UserCellProps {
  pubkey: string;
  metadata?: NostrMetadata;
  className?: string;
  size?: 'sm' | 'lg';
}

/** Compact avatar + name + short npub display used across tables and lists */
export function UserCell({ pubkey, metadata, className, size = 'sm' }: UserCellProps) {
  const name = displayName(pubkey, metadata);
  const npub = shortNpub(pubkey);

  return (
    <div className={cn('flex items-center gap-2 min-w-0', className)}>
      <Avatar className={size === 'lg' ? 'h-12 w-12' : 'h-8 w-8'}>
        <AvatarImage src={sanitizeUrl(metadata?.picture)} alt="" />
        <AvatarFallback className="text-xs">
          {name.slice(0, 2).toUpperCase()}
        </AvatarFallback>
      </Avatar>
      <div className="min-w-0">
        <p className={cn('font-medium truncate', size === 'lg' ? 'text-lg' : 'text-sm')}>
          {name}
        </p>
        <p className="text-xs text-muted-foreground font-mono truncate">{npub}</p>
      </div>
    </div>
  );
}
